import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const positive = (n) => (n < 0 ? -n : n)

function isActive(items, currentName) {
  if (!items) {
    return false
  }

  const founds = Object
    .keys(items)
    .filter((name) => items[name].visible)
    .sort((a, b) => {
      return positive(items[a].top) - positive(items[b].top)
    })


  return (founds.length && founds[0] === currentName)
}

class ScrollSpyWatch extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    group: PropTypes.string.isRequired,
    activeClass: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    activeClass: 'active'
  }

  constructor(props) {
    super(props)
    this.state = {
      isActive: isActive(props.groups[props.group], props.name)
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.groups[this.props.group] !== prevProps.groups[prevProps.group]) {
      this.setState({
        isActive: isActive(this.props.groups[this.props.group], this.props.name)
      })
    }
  }

  render() {
    return (
      <div className={`${this.props.className} ${this.state.isActive ? this.props.activeClass : ''}`}>
        {this.props.children}
      </div>
    )
  }
}

export default connect(
  (state) => ({ groups: state.scrollSpy })
)(ScrollSpyWatch)